<template>
  <page-status class="insure-payment" :loading="loading">
    <div class="header">车险投保缴费支付</div>

    <van-radio-group v-model="select">
      <van-cell-group>
        <van-cell>
          <cell-header slot="title" title="选择支付方式" />
        </van-cell>
        <van-cell
          v-for="(payment, index) in payments"
          :key="payment.code"
          @click="onPaymentSelect(index, payment.huaBeiList)"
        >
          <div class="payment" slot="title">
            <img :src="payment.value[1]" />
            <span>{{ payment.value[0] }}</span>
          </div>
          <van-radio slot="right-icon" :name="index" class="payment-radio" />
          <div
            slot="label"
            v-if="payment.huaBeiList && payment.huaBeiList.length > 0"
          >
            <van-row class="payment-credit-pay">
              <van-col
                span="12"
                v-for="(amount, i) in payment.huaBeiList"
                :key="amount.stages"
                @click.stop="onCreditPaySelect(i, index)"
                :class="{ active: i === creditPaySelect }"
              >
                <div class="item">
                  <div class="item-title">
                    ￥{{ amount.prinAndFee }}*{{ amount.stages }}期
                  </div>
                  <div>含手续费￥{{ amount.eachFee }}/期</div>
                </div>
              </van-col>
            </van-row>
          </div>
        </van-cell>
      </van-cell-group>
    </van-radio-group>

    <div class="footer">
      <div class="actions">
        <van-button type="info" block @click="onNextStep">下一步</van-button>
      </div>
      <page-footer />
    </div>
  </page-status>
</template>

<script>
import { Toast } from 'vant';
import PageStatus from '@/components/PageStatus';
import CellHeader from '@/components/CellHeader';
import PageFooter from '@/components/PageFooter';
import * as services from '@/services';
import { bindRecord } from '@/core/recorder';

export default {
  components: {
    PageStatus,
    CellHeader,
    PageFooter,
  },

  data() {
    return {
      loading: true,
      payments: [],
      select: -1,
      creditPaySelect: -1,
    };
  },

  created() {
    const token =
      this.$route.query.authToken || window.localStorage.getItem('authToken');
    window.localStorage.setItem('authToken', token);
    this.fetchData();
  },
  methods: {
    fetchData() {
      const { businessNo, businessSource } = this.$route.query;

      // 绑定用户
      if (businessNo) {
        bindRecord({ userId: businessNo });
      }

      services.getPaymentType(businessNo).then(res => {
        this.loading = false;
        this.payments =
          businessSource === 'ONLINE'
            ? [
                {
                  code: 'WEIXINJSAPI',
                  value: [
                    '微信',
                    'https://i3.cathay-ins.com.cn/prod/posts/583e20bcedffcf59010daa743353c0ba.png',
                  ],
                },
              ]
            : res.baseInfo.map(item => ({
                ...item,
                value: item.value.split('^'),
              }));
      });
    },

    onCreditPaySelect(i, index) {
      this.creditPaySelect = i;
      this.select = index;
    },

    onPaymentSelect(index, list = []) {
      this.select = index;
      this.creditPaySelect = list.length > 0 ? 0 : -1;
    },

    onNextStep() {
      if (this.select === -1) {
        Toast({ message: '请选择支付方式' });
        return;
      }

      Toast.loading({
        message: '正在提交...',
        forbidClick: true,
        duration: 0,
      });

      const { businessNo, mobile, businessSource } = this.$route.query;
      const payment = this.payments[this.select];
      const params = [businessNo, mobile, payment.code];
      if (payment.code === 'CREDITPAY') {
        const stages = payment.huaBeiList[this.creditPaySelect].stages;
        params.push(stages);
      }

      services.applyOrder(...params).then(res => {
        const query = {
          businessNo,
          mobile,
          payType: payment.code,
          payName: payment.value[0],
          poaCode: res.data,
          businessSource,
        };
        this.$router.push({ path: '/insure-qrcode', query });
        Toast.clear();
      });
    },
  },
};
</script>

<style lang="less">
.insure-payment {
  display: flex;
  min-height: 100%;
  flex-direction: column;

  .header {
    padding: 12px;
    color: #212121;
    font-weight: bold;
    font-size: 16px;
    text-align: center;
  }

  .payment {
    display: flex;
    align-items: center;
  }

  .payment img {
    width: 22px;
    margin-right: 6px;
  }

  .payment-radio {
    margin-top: 2px;
    align-items: flex-start;
  }

  .payment-credit-pay {
    padding-top: 8px;
    .item {
      border-radius: 4px;
      padding: 10px 4px;
      margin: 6px 6px;
      border: 1px solid #f5f5f5;
      text-align: center;
      .item-title {
        font-size: 14px;
        color: #666;
        margin-bottom: 2px;
      }
    }
    .active .item {
      border-color: #1989fa;
      color: #1989fa;
      .item-title {
        color: #1989fa;
      }
    }
  }

  .footer {
    margin-top: auto;

    .actions {
      padding: 12px 12px 0;
    }
  }
}
</style>
